import React from 'react';

export default function Headline({counter, title, filters, clearChallenges, clearSteps}) {

    const renderClearFilter = <div className="headline__cta">
        <button className="clear-all-btn" onClick={(counter === 2) ? clearSteps : clearChallenges}>Clear all</button>
    </div>;

    return(
        <h4 className="headline headline__pharma_small_blue_uppercase">
            <div className="headline__pharma_small_blue_uppercase headline__pharma_small_blue_uppercase--counter">{counter}</div>
            <p className="headline__content">{title}</p>
            {filters ? renderClearFilter : ''}
        </h4>
    );
}